// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1XQmq","label":"LabeledBox_label__3ZGip"};